<template>
    <div  id="info-view" class="info-view">
        <div class="container-fluid my-3">
            <div class="row px-1 d-block d-lg-flex">
                <div class="col-11 col-lg-6 image-div">
                    <responsive-picture-ob1
                        :dto="dto.image"
                        :css-classes="null"
                    />
                </div>
                <div class="text-div col-11 col-lg-7 pt-3 pb-1 px-1 p-lg-3 bg-gray2">
                    <h1 class="mb-0">{{ dto.pageTitle }}</h1>
                    <p v-if="dto.boldText" class="d-flex align-items-center">
                        <strong v-html="dto.boldText"></strong>
                    </p>
                    <p v-if="dto.text" class="mb-2" v-html="dto.text"></p>
                    <a
                        v-if="!isWebView || dto.showButtonInWebview"
                        :href="dto.buttonLink"
                        class="btn btn-secondary me-1 mb-1 mb-xl-0"
                        :data-oevent-category="dto.buttonTms.category"
                        :data-oevent-action="dto.buttonTms.action"
                        :data-oevent-label="dto.buttonTms.label"
                    >
                        {{ dto.buttonLabel }}
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ResponsivePictureOb1 from "../broadband/demands/ordering/components/ResponsivePictureOb1.vue";

const infoViewDto = JSON.parse(document.getElementById('info-view').dataset.dto);
const webView = JSON.parse(document.getElementById('info-view').dataset.webview);

export default {
    name: "InfoView",
    components: {
        ResponsivePictureOb1,
    },
    data() {
        return {
            dto: infoViewDto,
            isWebView: webView
        }
    }
}
</script>

<style scoped lang="scss">
@import 'ob1_variables';

.image-div {
    padding-left: 0;
    padding-right: 0;
    text-align: right;
    left: 8.333333%;
    @media (min-width: #{map-get($grid-breakpoints, lg)}) {
        position: relative !important;
        text-align: left;
        left: 0;
    }
}

.text-div {
    z-index:100;
    margin-top: -35px;
    @media (min-width: #{map-get($grid-breakpoints, lg)}) {
        height: 100%;
        margin-top: 45px;
        margin-left: -160px;
    }
    @media (min-width: #{map-get($grid-breakpoints, xl)}) {
        margin-left: -225px;
    }
}

</style>
